const mainTheme = {
  black100: '#000',
  black75: '#4A4A4A',
  primaryColor: "#EC7D28",
  primaryHover: "#C65E00",
  borderColor: "#dd9c64",
  hoverColorGray: "#F0F2F7",
  whiteBackground: "#fff",
  secondaryGrayColor: "#E4E7EF",
  interactionColor: "#B9055F",
  interactionColorDark: "#8D0E4E",
  customStylesSelectBackground: "red",
  redColor: "#EB5757",
  logoGradient1: "#e17301",
  logoGradient2: "#ff9100",
  logoGradient3: "#f6ae29",
  logo: require("images/Logo1.png"),
  logoWhite: require("images/Logo1White.png"),
  logoOrange: require("images/LogoOrange.png"),
  appTitle: "DAK Gesundheit",
};

export default mainTheme;
